import { Box } from '@mui/material';
import { ReactElement } from 'react';

function Separator(): ReactElement {
  return (
    <Box
      aria-hidden
      sx={{
        borderTop: 1,
        borderColor: 'divider',
        height: 0,
        m: 0,
        p: 0,
        width: '100%'
      }}
    />
  );
}

export { Separator };
